/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrefilledEmailResponseDTO
 */
export interface PrefilledEmailResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof PrefilledEmailResponseDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    to: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    cc: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    bcc: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    addMessage: string;
    /**
     * 
     * @type {string}
     * @memberof PrefilledEmailResponseDTO
     */
    subject: string;
    /**
     * 
     * @type {number}
     * @memberof PrefilledEmailResponseDTO
     */
    priority: number;
    /**
     * Whether this is a custom reply template.
     * @type {boolean}
     * @memberof PrefilledEmailResponseDTO
     */
    isCustom: boolean;
}

export function PrefilledEmailResponseDTOFromJSON(json: any): PrefilledEmailResponseDTO {
    return PrefilledEmailResponseDTOFromJSONTyped(json, false);
}

export function PrefilledEmailResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefilledEmailResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'to': json['to'],
        'cc': json['cc'],
        'bcc': json['bcc'],
        'message': json['message'],
        'addMessage': json['add_message'],
        'subject': json['subject'],
        'priority': json['priority'],
        'isCustom': json['is_custom'],
    };
}

export function PrefilledEmailResponseDTOToJSON(value?: PrefilledEmailResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'to': value.to,
        'cc': value.cc,
        'bcc': value.bcc,
        'message': value.message,
        'add_message': value.addMessage,
        'subject': value.subject,
        'priority': value.priority,
        'is_custom': value.isCustom,
    };
}

